import React, { useEffect, useState, useContext } from "react";
import jMoment from "moment-jalaali";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";

import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ProcessCard from "../components/ProcessCard";
import ProcessCardContainer from "../components/ProcessCardContainer";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const OrderDetailsInitials = (props) => {
  const data = props.data;
  const orderTypes = props.orderTypes;
  const doctorNames = props.doctorNames;
  const auth = useContext(AuthContext);

  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    new Date(Number(props.data.startDate))
  );
  //initializing the inputs
  const [formState, inputHandler, setFormData] = useForm(
    {
      patientName: {
        value: "",
        isValid: false,
      },
      doctorName: {
        value: "",
        isValid: false,
      },
      boxNumber: {
        value: "",
        isValid: true,
      },
      orderType: {
        value: "",
        // orderTypes.find(
        //     (orderType) => orderType.id == data.orderTypeId
        // ),,
        isValid: false,
      },
    },
    false
  );
  //input update hook
  useEffect(() => {
    setFormData(
      {
        patientName: {
          value: data.patiantName,
          isValid: true,
        },
        doctorName: {
          value: doctorNames.find((doctor) => doctor.id == data.doctorLabId),
          isValid: true,
        },
        boxNumber: {
          value: data.boxNumber,
          isValid: true,
        },
        orderType: {
          value: orderTypes.find(
            (orderType) => orderType.id == data.orderTypeId
          ),
          isValid: true,
        },
      },
      true
    );
    setIsLoading(false);
  }, [setFormData, data]);

  //sending up the validation
  useEffect(() => {
    props.setIsValid(formState.isValid);
  }, [formState.isValid]);

  //order update handler
  const orderUpdateHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    await axios
      .put(
        "/api/v1/laboratorys/update-order-details",
        {
          orderId: data.id,
          patiantName: formState.inputs.patientName.value,
          boxNumber: formState.inputs.boxNumber.value,
          orderTypeId: formState.inputs.orderType.value.id,
          startDate: new Date(startDate).getTime(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        setIsLoading(false);
      })
      .catch((e) => {
        console.log("error reached");
        console.log(e.response.data.data.length);
        console.log(e.response.data.message.message);
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;

        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  };

  //test
  // useEffect(() => {
  //   console.log(startDate);
  // }, [startDate]);

  return (
    <>
      {" "}
      {isLoading ? (
        <CircularProgress color="inherit" />
      ) : (
        <form onSubmit={orderUpdateHandler}>
          <Grid
            container
            spacing={2}
            sx={{ my: 2, py: 2, borderTop: 1, borderBottom: 1 }}
          >
            <Grid md={12} xs={12}>
              <Typography variant="h5" align="center" sx={{ mb: 2 }}>
                اطلاعات اولیه
              </Typography>
            </Grid>
            <Grid md={12} xs={12}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterJalaali}>
                  <DatePicker
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    // disableFuture={true}
                    label="تاریخ شروع"
                    disableMaskedInput
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size={"medium"}
                        variant={"outlined"}
                      />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>

            <Grid md={6} xs={12}>
              <Input
                id="patientName"
                element="input"
                label="نام بیمار"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام بیمار را وارد کنید."
                initialValue={formState.inputs.patientName.value}
                inputValid={formState.inputs.patientName.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="doctorName"
                element="autoComplete"
                label="نام پزشک"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا نام دکتر را انتخاب کنید."
                initialValue={formState.inputs.doctorName.value}
                inputValid={formState.inputs.doctorName.isValid}
                onInput={inputHandler}
                options={doctorNames}
                getOptionLabel={(option) => option.name}
                required={true}
                disabled={true}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="boxNumber"
                element="input"
                label="شماره جعبه"
                validators={[VALIDATOR_VALIDATED()]}
                errorText="لطفا شماره جعبه را وارد نمایید."
                onInput={inputHandler}
                initialValue={formState.inputs.boxNumber.value}
                inputValid={formState.inputs.boxNumber.isValid}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="orderType"
                element="autoComplete"
                label="نوع کار"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا نوع کار را انتخاب کنید."
                onInput={inputHandler}
                options={orderTypes}
                getOptionLabel={(option) => option.name}
                required={true}
                initialValue={formState.inputs.orderType.value}
                inputValid={formState.inputs.orderType.isValid}
              />
            </Grid>
            <Grid xs={12}>
              <Button
                disabled={!formState.isValid}
                type="submit"
                fullWidth
                color="secondary"
                variant="contained"
              >
                <EditIcon sx={{ mx: 1 }} />
                اعمال تغییرات
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

export default OrderDetailsInitials;
